module.exports = __webpack_public_path__ + "static/media/quindio-57.c948fcb2.jpg";